export const core = {
  localhostRelativeUrl: 'localhost:3000',
  contactEmail: 'admin@ourklyk.com',
}
